import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-duplicate-resolution-radio-group',
    template: `
		<mat-radio-group [(ngModel)]="resolution" (change)="onChange(this.resolution)">
			<div class="mb-2"><mat-radio-button value="update">Updating all fields</mat-radio-button></div>
			<div class="mb-2"><mat-radio-button value="append">Updating empty fields only</mat-radio-button></div>
			<div class="mb-2"><mat-radio-button value="skip">Skipping duplicates</mat-radio-button></div>
		</mat-radio-group>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: DuplicateResolutionRadioGroupComponent
        }
    ],
    standalone: false
})
export class DuplicateResolutionRadioGroupComponent implements ControlValueAccessor {
    resolution: string;

    writeValue(resolution: string) {
        this.resolution = resolution;
    }

    onChange = (resolution: string) => {};

    onTouched = () => {};

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }
}
